import React, { useState } from 'react';

const EXPECTED_ORDER = [
  'Deploy hotfix to production',
  'Notify stakeholders',
  'Run regression tests',
  'Update changelog',
  'Schedule post-mortem',
];

const INITIAL_ORDER = [
  'Schedule post-mortem',
  'Update changelog',
  'Deploy hotfix to production',
  'Run regression tests',
  'Notify stakeholders',
];

export default function C10_DragOrder({ onComplete }) {
  const [items, setItems] = useState(INITIAL_ORDER);
  const [dragging, setDragging] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const [confirmed, setConfirmed] = useState(false);

  const onDragStart = (idx) => setDragging(idx);
  const onDragOver = (e, idx) => { e.preventDefault(); setDragOver(idx); };
  const onDrop = (e, idx) => {
    e.preventDefault();
    if (dragging === null || dragging === idx) { setDragging(null); setDragOver(null); return; }
    const newItems = [...items];
    const [moved] = newItems.splice(dragging, 1);
    newItems.splice(idx, 0, moved);
    setItems(newItems);
    setDragging(null);
    setDragOver(null);
  };

  const handleConfirm = () => {
    setConfirmed(true);
    const correctCount = items.reduce((acc, item, i) => acc + (item === EXPECTED_ORDER[i] ? 1 : 0), 0);
    const pass = correctCount === EXPECTED_ORDER.length;
    const details = {};
    items.forEach((item, i) => {
      details[`position_${i + 1}`] = { expected: EXPECTED_ORDER[i], got: item, pass: item === EXPECTED_ORDER[i] };
    });
    onComplete({ score: Math.round((correctCount / EXPECTED_ORDER.length) * 100), details, passed: pass });
  };

  return (
    <div className="ab-challenge-ui">
      <p className="ab-hint">Drag the items to reorder them. Use the ≡ handle to drag.</p>
      <div className="ab-drag-list">
        {items.map((item, idx) => (
          <div
            key={item}
            className={`ab-drag-item ${dragging === idx ? 'ab-drag-item-dragging' : ''} ${dragOver === idx ? 'ab-drag-item-over' : ''}`}
            draggable={!confirmed}
            onDragStart={() => onDragStart(idx)}
            onDragOver={(e) => onDragOver(e, idx)}
            onDrop={(e) => onDrop(e, idx)}
            onDragEnd={() => { setDragging(null); setDragOver(null); }}
          >
            <span className="ab-drag-handle">≡</span>
            <span className="ab-drag-num">{idx + 1}</span>
            <span className="ab-drag-text">{item}</span>
          </div>
        ))}
      </div>
      {!confirmed
        ? <button className="ab-action-btn" onClick={handleConfirm}>Confirm Order</button>
        : <div className="ab-submitted-badge">✓ Order Confirmed — Evaluating...</div>
      }
    </div>
  );
}
